export enum HelpSection {
  Projects = "projects",
  Templates = "templates",
  Documents = "documents",
  Toolbox = "toolbox",
  Menu = "menu"
}
